import { IHeroLmpSlim } from '@sky-it-livedata/livedata-sports-design-system';
import { ErrorName, WidgetError } from "../../../utils/errors";
import { isValidLmpHeroStickyQuery } from "./typeguards";
import { CreateLmpHeroInputSchema } from "appsync";
import { LmpHeroStickyQuery } from "../types";



type ITransformedMatch = IHeroLmpSlim['match'] & {
  customCompetitionName?: string;
};

const transformerQuery = (obj: LmpHeroStickyQuery): IHeroLmpSlim => {
  
  if (isValidLmpHeroStickyQuery(obj)) {
    CreateLmpHeroInputSchema().parse(obj.data?.getLmpHeroSticky);
    const { competition, matchId, createdAt, updatedAt, ...match } = obj.data.getLmpHeroSticky;

    const transformedMatch = ({
      ...match,
      customCompetitionName: competition?.name ?? undefined,
    } as unknown) as ITransformedMatch;
    
    const { negativeLogoUrl:negativeLogoUrlHome, ...home } = match.home!;
    const { negativeLogoUrl:negativeLogoUrlAway, ...away } = match.away!;


    const payload: IHeroLmpSlim = {
      hasVideo: false,
      isSlim: true,
      match: {
        ...transformedMatch,
        matchId,
        away: {
          ...away,
          logoUrl: negativeLogoUrlAway || away.logoUrl,
        } as ITransformedMatch['away'],
        home: {
          ...home,
          logoUrl: negativeLogoUrlHome || home.logoUrl,
        } as ITransformedMatch['home'],
      },
    };

    return payload;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in LmpHeroStickyQuery object",
      data: obj,
    });
  }
};

export default transformerQuery;
